import { EmptyState, FlexBox } from '@dixa/lib-shared-habla';

export function KnowledgeErrorPlaceholder(): JSX.Element {
  return (
    <FlexBox height="100%" flex="1" justifyContent="center" alignItems="center">
      <EmptyState
        size="large"
        title="Something went wrong, please reload and try again"
        description="If this issue persists, please contact support."
      />
    </FlexBox>
  );
}
